/** @format */

import React, { useState, useEffect, useContext } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import { useHistory } from 'react-router-dom';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { payOptionService } from '../../Services/payoption.service';
import ListAdminButtons from '../Common/ListAdminButtons';
import ResultModal from '../Common/ResultModal';
import { useTranslation } from 'react-i18next';
import DeleteModal from '../PayOption/DeleteModal';
import { GlobalContext } from '../../Contexts/GlobalContextProvider';
import SpinnerLoading from '../Common/SpinnerLoading';
import { AuthContext } from '../../Contexts/AuthContext';
import { roles } from '../../Config/Roles';
import Tooltip from '../Common/Tooltip';

const Index = () => {
	const { t: translator } = useTranslation();
	const { updateLocTab, updateLocName, isMobile } = useContext(GlobalContext);
	const { roleId } = useContext(AuthContext);
	const { master, admin } = roles;
	const [payOptions, setPayOptions] = useState([]);
	const [isLoading, setIsLoading] = useState(true);
	const [pagination, setPagination] = useState({
		totalCount: 0,
		pageSize: 10,
		pageIndex: 0,
	});
	const [modal, setModal] = useState({
		title: '',
		text: '',
		show: false,
		btnClass: '',
	});
	const [update, setUpdate] = useState(new Date());
	const [selectedItems, setSelectedItems] = useState([]);
	const [searchName, setSearchName] = useState('');
	const history = useHistory();
	const [showDeleteModal, setShowDeleteModal] = useState(false);

	useEffect(() => {
		updateLocName('pay-methods');
		payOptionService
			.get({
				searchName,
				pageIndex: pagination.pageIndex,
				pageSize: pagination.pageSize,
			})
			.then(res => {
				setIsLoading(false);
				setPayOptions(res.data.payOptions.filter(x => !x.tenantId));
				setPagination({ ...pagination, totalCount: res.data.totalCount });
			})
			.catch(err => {
				console.error(err.response);
			});
		updateLocTab(0);
	}, [update, searchName]);

	const AddPayOption = () => {
		history.push('/add-pay-methods');
	};

	const handleClose = () => {
		setModal({ show: false });
		setSelectedItems([]);
		history.push('/pay-methods');
	};

	const handleOnSelect = (row, isSelect) => {
		if (isSelect) {
			setSelectedItems([...selectedItems, row.payOptionId]);
		} else {
			setSelectedItems(selectedItems.filter(p => p !== row.payOptionId));
		}
	};

	const handleOnSelectAll = (isSelect, rows) => {
		if (isSelect) {
			setSelectedItems(payOptions.map(x => x.payOptionId));
		} else {
			setSelectedItems([]);
		}
	};

	const handleToUpdate = () => {
		if (selectedItems.length !== 1) return false;
		history.push(`/update-pay-methods/${selectedItems}`);
	};

	const handleTableChange = (type, { page, sizePerPage }) => {
		setPagination({
			...pagination,
			pageIndex: page - 1,
			pageSize: sizePerPage,
		});
		setUpdate(new Date());
	};

	function actionFormatter(cell, row) {
		return (
			<div className='action'>
				<label className='labelCont'>
					<input
						type='checkbox'
						checked={selectedItems.find(x => x === row.payOptionId)}
						onChange={e => handleOnSelect(row, e.target.checked)}
					/>
					<span className='checkmark'></span>
				</label>
			</div>
		);
	}

	function actionHeaderFormatter(cell, rows) {
		return (
			<div className='action'>
				<label className='labelCont'>
					<input
						type='checkbox'
						checked={
							payOptions &&
							payOptions.length > 0 &&
							!payOptions
								.map(p => p.payOptionId)
								.some(p => selectedItems.indexOf(p) < 0)
						}
						onChange={e => handleOnSelectAll(e.target.checked)}
					/>
					<span className='checkmark'></span>
				</label>
			</div>
		);
	}
	const RemoteAll = ({ data, page, sizePerPage, totalSize, onTableChange }) => (
		<div>
			<BootstrapTable
				remote
				keyField='payOptionId'
				data={data}
				columns={columns}
				noDataIndication={translator('No-Data')}
				rowClasses='boostrap-table-row'
				pagination={paginationFactory({
					page,
					sizePerPage,
					totalSize,
				})}
				onTableChange={onTableChange}
			/>
		</div>
	);

	const columns = [
		{
			dataField: 'payOptionId',
			text: '',
			headerStyle: (colum, colIndex) => {
				return { width: '50px', textAlign: 'center' };
			},
			headerFormatter: actionHeaderFormatter,
			formatter: actionFormatter,
			hidden: [master, admin].includes(Number(roleId)) ? false : true,
		},
		{
			dataField: 'name',
			text: translator('PayOption-View-TableHeader-Name'),
		},
		{
			dataField: 'tag',
			text: translator('PayOption-View-TableHeader-Tag'),
			hidden: Boolean(isMobile),
		},
		{
			dataField: 'fiscalTag',
			text: translator('PayOption-View-TableHeader-FiscalTag'),
			hidden: Boolean(isMobile),
		},
	];

	const handleHideDeleteModal = () => setShowDeleteModal(false);

	const confirmDelete = () => {
		let deletePromises = [];

		selectedItems.forEach(x => {
			deletePromises.push(payOptionService.deletePayOption(x));
		});

		Promise.all(deletePromises)
			.then(data => {
				setShowDeleteModal(false);
				setModal({
					...modal,
					title: translator('PayOptions-ResultModal-DeleteSuccess-Titl'),
					text: translator('PayOptions-ResultModal-DeleteSuccess-Text'),
					show: true,
					btnClass: 'btn btn-primary',
				});
				setUpdate(new Date());
			})
			.catch(err =>
				setModal({
					...modal,
					title: translator('PayOptions-ResultModal-DeleteSuccess-Titl'),
					text: translator('PayOptions-ResultModal-DeleteUnSuccess-Text'),
					show: true,
					btnClass: 'btn btn-primary',
				}),
			);
	};

	return (
		<div className='p-2 pt-3'>
			<div className='card container-fluid p-0'>
				<div className='card-header card-wrap'>
					<span>{translator('PayOption-View-Subtitle')}</span>
					{[master, admin].includes(Number(roleId)) && (
						<button
							className={
								'btn btn-primary float-right' + (isMobile ? ' btn-sm' : '')
							}
							onClick={AddPayOption}>
							<span
								className='icon icon-cancel web-hidden'
								style={{ transform: 'rotate(45deg)' }}></span>{' '}
							<span className='mob-hidden'>
								{translator('PayOption-View-AddPayOption')}
							</span>
						</button>
					)}
				</div>
				<div className='card-body'>
					<fieldset className='scheduler-border'>
						<legend className='scheduler-border'>
							{translator('PayOption-View-Filters')}
						</legend>
						<form
							className='row'
							onSubmit={e => {
								e.preventDefault();
							}}>
							<div className='form-group col-lg-3 col-md-4 col-xs-12'>
								<label>{translator('PayOption-View-Name')}</label>{' '}
								<Tooltip text={translator('PayOptionTooltip-Msg')} />
								<input
									type='text'
									className='form-control'
									value={searchName}
									onChange={event => {
										setSearchName(event.target.value);
										setPagination({ ...pagination, pageIndex: 0 });
									}}
								/>
							</div>
						</form>
					</fieldset>
					{[master, admin].includes(Number(roleId)) && (
						<ListAdminButtons
							selectedItemsLength={selectedItems.length}
							handleToUpdate={handleToUpdate}
							handleDelete={() => setShowDeleteModal(true)}
						/>
					)}

					{isLoading && (
						<div className='dashboard-card-spinner'>
							<SpinnerLoading />
						</div>
					)}

					{!isLoading && (
						<RemoteAll
							data={payOptions}
							page={pagination.pageIndex + 1}
							sizePerPage={pagination.pageSize}
							totalSize={pagination.totalCount}
							onTableChange={handleTableChange}
						/>
					)}
				</div>
			</div>

			<DeleteModal
				show={showDeleteModal}
				handleHide={handleHideDeleteModal}
				title={translator('PayOption-DeleteModal-Title')}
				text={translator('PayOption-DeleteModal-Text')}
				confirmDelete={confirmDelete}
			/>
			<ResultModal
				show={modal.show}
				title={modal.title}
				text={modal.text}
				btnClass={modal.btnClass}
				handleClose={handleClose}
			/>
		</div>
	);
};

export default Index;
